import { Box, BoxProps } from "@mui/material";
import React from "react";

export const NoPropagateBox = ({
  children,
  ...props
}: React.PropsWithChildren<BoxProps>) => {
  return (
    <Box
      onMouseDown={e => {
        e.stopPropagation();
      }}
      onTouchStart={e => {
        e.stopPropagation();
      }}
      onClick={e => {
        e.preventDefault();
        e.stopPropagation();
      }}
      onKeyDown={e => {
        if (e.key === "Tab") {
          return;
        }
        e.stopPropagation();
      }}
      {...props}
    >
      {children}
    </Box>
  );
};
